import React, { Component } from "react";
import * as pr from "../../common/PrimeComponents";
import * as Log from "../../common/Feedback/Log";
import { CrudlStatus } from "../../common/config/AppConstants";

export class MVVMToolbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null,
      errors: []
    };

    this.logger = Log;
  }

  render() {
    return (
      <div className="ui-g-12">
        <pr.Toolbar style={{ backgroundColor: this.props.backgroundColor }}>
          <div className="p-toolbar-group-left">
            {/* <pr.MultiSelect
              style={
                this.props.editMode
                  ? { display: "none" }
                  : { marginRight: ".25em", float: "left" }
              }
              value={this.props.tableColumns}
              options={this.props.columnOptions}
              onChange={this.props.updateColumns}
            /> */}
            <pr.BreadCrumb
              model={this.props.menuState}
              home={pr.getBreadcrumbMenuHome()}
              style={{
                backgroundColor: "transparent",
                float: "left",
                color: "white"
              }}
            />
            <pr.Button
              icon="pi pi-times"
              className="p-button-danger"
              style={
                this.props.crudlState === CrudlStatus.CREATE ||
                this.props.crudlState === CrudlStatus.UPDATE
                  ? {
                      marginRight: ".25em",
                      float: "right",
                      backgroundColor: this.props.buttonColour
                    }
                  : { display: "none" }
              }
              onClick={() => {
                this.props.validateChanges();
              }}
            />
            <pr.Button
              icon="pi pi-plus"
              style={
                this.props.crudlState === CrudlStatus.CREATE ||
                this.props.crudlState === CrudlStatus.UPDATE
                  ? { display: "none" }
                  : {
                      marginRight: ".25em",
                      float: "right",
                      background: this.props.buttonColour
                    }
              }
              onClick={() => {
                this.props.crudlControl(CrudlStatus.CREATE);
              }}
            />
            <pr.Button
              type="button"
              style={
                this.props.crudlState === CrudlStatus.CREATE ||
                this.props.crudlState === CrudlStatus.UPDATE
                  ? { display: "none" }
                  : {
                      marginRight: ".25em",
                      float: "right",
                      background: this.props.buttonColour
                    }
              }
              icon="pi pi-external-link"
              onClick={this.props.export}
            ></pr.Button>
            <pr.Button
              type="button"
              style={
                this.props.crudlState === CrudlStatus.CREATE ||
                this.props.crudlState === CrudlStatus.UPDATE
                  ? { display: "none" }
                  : {
                      marginRight: ".25em",
                      float: "right",
                      background: this.props.buttonColour
                    }
              }
              icon={
                this.props.loading === true
                  ? "pi pi-spin pi-spinner"
                  : "pi pi-refresh"
              }
              onClick={this.props.refresh}
            ></pr.Button>
            {this.props.runCrudOverride ? (
              <label></label>
            ) : (
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                onClick={() => {
                  this.props.crudlExecute(this.props.crudlState);
                }}
                style={
                  this.props.crudlState === CrudlStatus.CREATE ||
                  this.props.crudlState === CrudlStatus.UPDATE
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        background: this.props.buttonColour
                      }
                    : { display: "none" }
                }
              />
            )}
          </div>
        </pr.Toolbar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/MVVMToolbar.js